import React, { useCallback, useEffect, useState } from 'react';
import './styles/AboutPage.css';
import Container from '../components/Container';
import Navbar from '../components/Navbar';
import { useNavigate } from 'react-router-dom';
import { captureEvent } from '../utils/posthogClient';
import { fetchCurrentlyReadingTitle } from '../utils/supabase';

export default function AboutPage() {
  const navigate = useNavigate();
  const [currentlyReadingTitle, setCurrentlyReadingTitle] = useState<
    string | null
  >(null);

  useEffect(() => {
    fetchCurrentlyReadingTitle().then(setCurrentlyReadingTitle);
  }, []);

  const handleFavoritesNavigate = useCallback(() => {
    navigate('/?favorite=true');
  }, [navigate]);

  return (
    <Container>
      <Navbar currentIndex={1} />

      <div className="about-container">
        <div className="question-container">
          <div className="label-bold">What is this?</div>
          <div className="label">
            This is a project dedicated to reflect on the books I have read. A
            way to stay consistent and preserve my thoughts.
          </div>
          <div className="label">
            I own a personal copy of many books featured here and am always
            happy to lend them to friends.
          </div>
        </div>

        <div className="main-content">
          {/* It's possible that I haven't picked a new book after finishing a review. */}
          {currentlyReadingTitle?.length > 0 && (
            <div className="question-container">
              <div className="label-bold">What are you currently reading?</div>

              <div className="label">
                <i>{currentlyReadingTitle}</i>
              </div>
            </div>
          )}

          <div>
            <b>Note:</b> After five years of maintaining this blog, I'm unsure
            where I want to take this next! I question if people extract any
            value from what essentially boils down to a Goodreads review, and as
            of late I've been much more passionate about music and my own
            writing. I'll try to keep this up to date, and by no means does this
            mean my journey of reading ends here. Much love to all those who
            came across this over the years &lt;3
          </div>

          <div className="question-container">
            <div className="label-bold">Favorites?</div>

            <div className="link" onClick={handleFavoritesNavigate}>
              Click here to see all of my favorites here.
            </div>
          </div>

          <div className="question-container">
            <div className="label-bold">Favorite writers?</div>

            <ul>
              <li>
                David Foster Wallace - my all time favorite is{' '}
                <a href="/review/infinite-jest" className="link">
                  Infinite Jest
                </a>
                .
              </li>
              <li>
                Joan Didion - I go back to{' '}
                <a href="/review/the-white-album" className="link">
                  The White Album
                </a>{' '}
                a lot for life inspo.
              </li>
            </ul>
          </div>

          <div className="label row">
            Last updated 2026. See source code&nbsp;
            <div
              className="link"
              onClick={() => {
                captureEvent('clicked_source_code');
                window.location.href =
                  'https://github.com/jinsung-kim/book-blog';
              }}
            >
              here
            </div>
            .
          </div>
        </div>
      </div>
    </Container>
  );
}
